/* Narc Ranger header (sections/nr-header.liquid) */
(function () {
  function initNrHeader(root) {
    if (!root || root.dataset.nrReady) return;
    root.dataset.nrReady = '1';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-nr-trigger]'));
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer;

    function panelFor(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }
    function closeAll(except) {
      triggers.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var p = panelFor(b); if (p) p.hidden = true;
      });
    }
    function open(btn) {
      clearTimeout(closeTimer);
      closeAll(btn);
      btn.setAttribute('aria-expanded', 'true');
      var p = panelFor(btn); if (p) p.hidden = false;
    }
    function toggle(btn) {
      if (btn.getAttribute('aria-expanded') === 'true') closeAll(); else open(btn);
    }

    triggers.forEach(function (btn) {
      var panel = panelFor(btn);
      btn.addEventListener('click', function () {
        /* with a mouse, hover already opened it: a click keeps it open instead of closing it */
        if (canHover.matches) open(btn); else toggle(btn);
      });
      btn.addEventListener('mouseenter', function () { if (canHover.matches) open(btn); });
      btn.addEventListener('mouseleave', function () { if (canHover.matches) closeTimer = setTimeout(closeAll, 180); });
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', function () { if (canHover.matches) closeTimer = setTimeout(closeAll, 180); });
      }
    });

    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openBtn = triggers.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      closeAll();
      if (openBtn) openBtn.focus();
      if (root.classList.contains('is-menu-open')) setMenu(false);
    });

    /* compact on scroll */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        root.classList.toggle('is-compact', window.scrollY > 40);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* mobile drawer */
    var burger = root.querySelector('[data-nr-burger]');
    var bar = root.querySelector('.nrh__bar');
    function setMenu(isOpen) {
      root.classList.toggle('is-menu-open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      root.style.setProperty('--nrh-top', bar.getBoundingClientRect().bottom + 'px');
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
    }
    if (burger) burger.addEventListener('click', function () { setMenu(!root.classList.contains('is-menu-open')); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1100 && root.classList.contains('is-menu-open')) setMenu(false); });

    Array.prototype.forEach.call(root.querySelectorAll('[data-nr-acc]'), function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (sub) sub.hidden = isOpen;
      });
    });
  }
  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-nr-header]'), initNrHeader); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  /* theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', initAll);
})();
